import { PrimaryControlsStripExpansion } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.expansion";
import {
  BrowseLearnedProgress,
  useBrowseDatasetStatsQueryOptions,
} from "@-/dev.improve.haniverse.routes.nav.app.browse._components.dataset-stats";
import { BrowsePrimaryControlsStripExpansionPushButtons } from "@-/dev.improve.haniverse.routes.nav.app.browse._components.primary-controls-strip-expansion-push-buttons";
import { useStudiedGraphemesQueryOptions } from "@-/dev.improve.haniverse.lib.cards.user-card.grapheme.meaning.read";
import { useQuery } from "@-/com.npmjs.tanstack__react-query";
import { useMemo } from "react";
import arrayLength from "@-/com.npmjs.extra-array__length";

/**
 * Header expansion strip for the Browse Primitives page: how many of the HSK-dataset
 * primitives the user has learned. A primitive counts as learned when its glyph is in the
 * user's studied-grapheme set.
 */
export function BrowsePrimitivesPrimaryControlsStripExpansionContent() {
  const { data: stats } = useQuery(useBrowseDatasetStatsQueryOptions());
  const { data: studiedGraphemes } = useQuery(useStudiedGraphemesQueryOptions());

  const { learnedCount, totalCount } = useMemo(() => {
    const primitives = stats?.primitives ?? [];
    const studied = studiedGraphemes ?? new Set<string>();
    let learned = 0;
    for (const primitive of primitives) {
      if (studied.has(primitive)) {
        learned++;
      }
    }
    return { learnedCount: learned, totalCount: arrayLength(primitives) };
  }, [studiedGraphemes, stats]);

  return (
    <PrimaryControlsStripExpansion>
      <BrowseLearnedProgress learnedCount={learnedCount} noun="primitive" totalCount={totalCount} />
      <BrowsePrimaryControlsStripExpansionPushButtons />
    </PrimaryControlsStripExpansion>
  );
}
